/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuditLogFilters {
    getFixupPrototypeFunction() { return AuditLogFilters.fixupPrototype; }

    static newInstance(model: Partial<AuditLogFilters>): AuditLogFilters {
        let obj = Object.assign(new AuditLogFilters(), model);
        AuditLogFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuditLogFilters>): AuditLogFilters {
        if (!model) return null;
        return AuditLogFilters.newInstance(<AuditLogFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuditLogFilters) {
        if (!obj) return;

        models.AuditLogFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuditLogFilters): boolean {
        Object.setPrototypeOf(obj, AuditLogFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
    }

    /**
     * Filter from date
     */
    from_date: Date;

    /**
     * Filter to date
     */
    to_date: Date;

    /**
     * Filter by master account ids
     */
    master_account_id: Array<string>;

    /**
     * Filter by accounts
     */
    master_account_names: Array<string>;

    /**
     * Filter by tenants
     */
    tenant_names: Array<string>;

    /**
     * Filter by users
     */
    user_names: Array<string>;

    /**
     * Filter by event types
     */
    event_types: Array<models.AuditLogEventType>;

    /**
     * Filter by event actions
     */
    event_actions: Array<models.AuditLogEventAction>;

}
